import { lazy } from "react";
import { APPEARANCE } from "pages/routes/route.constant";
const appearance = lazy(() => import("pages/Appearance"));

export default {
  path: APPEARANCE,
  element: appearance,
};
